const GiveawayEvent = ({ event, getPlayerName, getTeamAbbreviation }) => {
    const giveawayPlayerId = event.details?.giveawayPlayerId;
    const giveawayPlayerName = getPlayerName(giveawayPlayerId);
    const giveawayPlayerMugshotUrl = giveawayPlayerId ? `https://assets.nhle.com/mugs/nhl/20242025/${getTeamAbbreviation(event.details?.eventOwnerTeamId)}/${giveawayPlayerId}.png` : null;

    return (
        <div className="flex items-center mb-2">
            <span className="text-sm font-semibold text-gray-700 mr-2">Time:</span>
            <span className="text-sm text-gray-900 mr-2">{event.timeInPeriod}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">Period:</span>
            <span className="text-sm text-gray-900 mr-2">{event.periodDescriptor.number}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">{giveawayPlayerName}</span>
            {giveawayPlayerMugshotUrl && (
                <img
                    src={giveawayPlayerMugshotUrl}
                    alt={giveawayPlayerName}
                    className="inline-block ml-2 w-8 h-8 rounded-full"
                />
            )}
            <span className="text-sm font-semibold text-gray-700 ml-2">Giveaway</span>
        </div>
    );
};

export default GiveawayEvent;